import { getKaiChatConfig } from '../constants/kaiChatConfig';
import { createKaiCopilotService } from '../services/kaiCopilotService';
import { shouldUseShellKaiProxy } from './platformKaiRouting';

function resolveApiBase(serviceKey) {
  const config = getKaiChatConfig(serviceKey);
  if (shouldUseShellKaiProxy() && config.shellApiPrefix) {
    return config.shellApiPrefix;
  }
  if (typeof window === 'undefined') {
    return `http://localhost:${config.backendPort}`;
  }
  const hostname = window.location.hostname;
  const port = window.location.port || (window.location.protocol === 'https:' ? '443' : '80');
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';
  if (config.frontendPort && String(port) === String(config.frontendPort)) {
    return '';
  }
  if (!isLocal) return '';
  return `http://${hostname}:${config.backendPort}`;
}

export function createShellKaiCopilotService(serviceKey) {
  const config = getKaiChatConfig(serviceKey);
  return createKaiCopilotService({
    backendPort: config.backendPort,
    frontendPort: config.frontendPort,
    apiBaseUrl: resolveApiBase(serviceKey),
  });
}

export function createPatientPortalKaiService() {
  const apiBase = shouldUseShellKaiProxy() ? '/patient-api/v1' : 'http://localhost:8225/api/v1';

  const request = async (endpoint, options = {}) => {
    const url = `${apiBase}${endpoint}`;
    const response = await fetch(url, {
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
      ...options,
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  };

  return {
    async chat(message, userId = 'user', context = {}, conversationId = null) {
      const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
      return request('/agent/chat', {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: JSON.stringify({
          message,
          user_id: userId,
          conversation_id: conversationId,
          context: { ...context, service: 'patient_portal' },
        }),
      });
    },
  };
}

export function createCopilotServiceForKey(serviceKey) {
  if (serviceKey === 'patient_portal') {
    return createPatientPortalKaiService();
  }
  return createShellKaiCopilotService(serviceKey);
}
